import * as React from 'react';
import { Props } from 'react';
import { connect, Dispatch } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import * as queryString from 'query-string';

import { AppState } from '../../reducers';

import { setChannelUserIdAction, setUserPhoneAction, setChannelIdAction, setUserLangAction } from '../../actions/user';
import { registrationAction, setBinAction, setNameAction, setSurnameAction, checkBinAction, resetRegistrationAction } from '../../actions/Registration/registration';
import { authorizationAction } from '../../actions/Authorization/authorization';

import { RegistrationView } from './RegistrationView';
import Spiner from '../RegistrationAuthorization/Spiner/Spiner';

import i18next from 'i18next';

interface RouteProps extends RouteComponentProps<{}> {
    match: any;
    history: any;
}

interface RegistrationContainerProps extends Props<RegistrationContainer> {
    checkBin: boolean;
    loadingCheckBin: boolean;
    errorCheckBin: string | null;

    registration: boolean;
    loadingRegistration: boolean;
    errorRegistration: {
        error: string;
        message: {
            ru: string;
        };
        code: number;
    } | null;

    bin: string;
    name: string;
    surname: string;

    lang: string;
    phone: string;
    code: string;

    channelUserId: string;
    channelId: string;
}

interface RegistrationContainerDispatch extends Props<RegistrationContainer> {
    setLang: (lang: string) => any;
    setPhone: (phone: string) => any;
    setChannelUserId: (channelUserId: string) => any;
    setChannelId: (channelId: string) => any;
    setBin: (bin: string) => any;
    setName: (name: string) => any;
    setSurname: (surname: string) => any;
    onCheckBin: (bin: string) => any;
    onRegistration: (bin: string, name: string, surname: string, phone: string) => any;
    resetRegistration: () => any;
    onAuthorization: (phone: string, channelUserId: string) => any;
}

function mapProps(state: AppState, props: RegistrationContainerProps): RegistrationContainerProps {
    return {
        checkBin: state.registrationState.checkBin,
        loadingCheckBin: state.registrationState.loadingCheckBin,
        errorCheckBin: state.registrationState.errorCheckBin,

        registration: state.registrationState.registration,
        loadingRegistration: state.registrationState.loadingRegistration,
        errorRegistration: state.registrationState.errorRegistration,

        bin: state.registrationState.bin,
        name: state.registrationState.name,
        surname: state.registrationState.surname,

        lang: state.userState.lang,
        phone: state.userState.phone,
        code: state.userState.code,

        channelUserId: state.userState.channelUserId,
        channelId: state.userState.channelId,
    };
}

function mapDispatch(dispatch: Dispatch<any>): RegistrationContainerDispatch {
    return {
        setLang: (lang: string) => dispatch(setUserLangAction(lang)),
        setPhone: (phone: string) => dispatch(setUserPhoneAction(phone)),
        setChannelUserId: (channelUserId: string) => dispatch(setChannelUserIdAction(channelUserId)),
        setChannelId: (channelId: string) => dispatch(setChannelIdAction(channelId)),
        setBin: (bin: string) => dispatch(setBinAction(bin)),
        setName: (name: string) => dispatch(setNameAction(name)),
        setSurname: (surname: string) => dispatch(setSurnameAction(surname)),
        onCheckBin: (bin: string) => dispatch(checkBinAction(bin)),
        onRegistration: (bin: string, name: string, surname: string, phone: string) => dispatch(registrationAction(bin, phone, name, surname)),
        resetRegistration: () => dispatch(resetRegistrationAction()),
        onAuthorization: (phone: string, channelUserId: string) => dispatch(authorizationAction(phone, channelUserId)),
    };
}

interface RegistrationContainerState {
    error: string;
}

class RegistrationContainer extends React.Component<RegistrationContainerProps & RegistrationContainerDispatch & RouteProps, RegistrationContainerState> {
    state = {
        error: ''
    };

    async componentDidMount() {
        const { history, setPhone, setChannelUserId, setChannelId, setLang, lang } = this.props;
        if (history.location.search) {
            const params = queryString.parse(history.location.search);
            const phone = params.phone;
            const channelUserId = params.user_id;
            const channelId = params.channel_id;
            const error = params.error;
            const language = params.lang;
            if (!lang) {
                setLang(language || 'ru');
            }
            if (language && language !== lang && i18next.languages.some(it => it === lang)) {
                setLang(language);
                await i18next.changeLanguage(language);
            }

            if (channelId) {
                setChannelId(channelId);
            }
            if (phone) {
                setPhone(phone);
            }
            if (channelUserId) {
                setChannelUserId(channelUserId);
            }
            if (error) {
                this.setState({
                    error
                });
            }
        }
    }

    componentWillUnmount() {
        const {resetRegistration} = this.props;
        resetRegistration();
    }

    componentWillReceiveProps(nextProps: RegistrationContainerProps & RegistrationContainerDispatch & RouteProps) {
        const { registration, history, phone, channelUserId, channelId, lang } = nextProps;
        if (registration && (registration !== this.props.registration)) {
            history.push(`/registration/sendCode?channel_id=${channelId}&phone=${phone}&user_id=${encodeURIComponent(channelUserId)}&lang=${lang}`);
        }
    }

    setBin = (bin: string) => {
        const {setBin, onCheckBin} = this.props;
        setBin(bin);
        if (bin.length === 6) {
            onCheckBin(bin);
        }
    }

    render() {
        document.title = i18next.t('registration');
        const { setPhone, phone, onRegistration, channelUserId, bin, name, surname, channelId, lang } = this.props;
        const { loadingRegistration, errorRegistration, setName, setSurname, checkBin, errorCheckBin, onAuthorization } = this.props;
        const { history } = this.props;

        const bankNumber = i18next.t('bank_phone');
        const NOT_ALLOW = i18next.t('authorization_not_allowed', { phone: `<a style="color:white" href=tel:${bankNumber}>${bankNumber}</a>` });

        let error = this.state.error;

        if (errorCheckBin) {
            error = errorCheckBin;
        }

        if (errorRegistration) {
            if (errorRegistration.code === 4 || errorRegistration.code === 1 || errorRegistration.code === 2 || errorRegistration.code === 7) {
                error = NOT_ALLOW;
            }
            if (errorRegistration.code === 8) {
                onAuthorization(phone, channelUserId);
                history.push(`/authorization/sendCode?channel_id=${channelId}&phone=${phone}&user_id=${encodeURIComponent(channelUserId)}&lang=${lang}`);
            }
        }

        if (loadingRegistration) {
            return <Spiner channelId={channelId} />;
        }

        return (
            <RegistrationView
                bin={bin}
                name={name}
                surname={surname}
                phone={phone}
                checkBin={checkBin}
                setBin={this.setBin}
                setName={setName}
                setSurname={setSurname}
                setPhone={setPhone}
                onRegistration={() => onRegistration(bin, name, surname, phone)}
                error={error}
                channelId={channelId}
            />
        );
    }
}

export default withRouter(connect(mapProps, mapDispatch)(RegistrationContainer));



// WEBPACK FOOTER //
// ./src/components/Registration/RegistrationContainer.tsx